

export default {
  jsonld() {
    return {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "Organization",
          "@id": `${process.env.BASE_URL}/#organization`,
          "name": `${this.$config.siteName}`,
          "url": process.env.BASE_URL,
          "email": "support@webtoolsmate.com",
          "logo":{
            "@type": "ImageObject",
            "@id": `${process.env.BASE_URL}/#logo`,
            "url": `${process.env.BASE_URL}/assets/images/webtoolsmate-logo.png`,
            "contentUrl": `${process.env.BASE_URL}/assets/images/webtoolsmate-logo.png`,
            "caption": `${this.$config.siteName}`,
            "inLanguage": "en-US",
            "width": "512",
            "height": "512"
          },
          "sameAs": this.$config.socialLinks
        },
        {
          "@type":"WebSite",
          "url":`${process.env.BASE_URL}`,
          "name":`${this.$config.siteName}`,
          "inLanguage":"en-US",
          "publisher":{
            "@id": `${process.env.BASE_URL}/#organization`
          },
          "potentialAction":{
            "@type":"SearchAction",
            "target": `${process.env.BASE_URL}/search/{search_term_string}`,
            "query-input":"required name=search_term_string"
          }
        }
      ]
    };
  },
  head() {
    return {
      title: `Contact Us | ${this.$config.siteName}`,
      meta: [
        { hid: 'title', name: 'title', content: `Contact Us | ${this.$config.siteName}` },
        { hid: 'description', name: 'description', content: `Our service team is here to assist with inquiries. Contact us using the form below, and we'll do our best to help.` },
        // Facebook meta settings
        { hid: 'og:site_name', property: 'og:site_name', content: `${this.$config.siteName}` },
        { hid: 'og:title', property: 'og:title', content: `Contact Us | ${this.$config.siteName}` },
        { hid: 'og:description', property: 'og:description', content: `Our service team is here to assist with inquiries. Contact us using the form below, and we'll do our best to help.` },
        { hid: 'og:type', property: 'og:type', content: 'article' },
        { hid: 'og:image', property: 'og:image', content: `https://webtoolsmate.com/storage/social/pages/contact.png` },
        { hid: 'og:url', property: 'og:url', content: `https://webtoolsmate.com/contact` },
        { hid: 'og:locale', property: 'og:locale', content: 'en_US' },
        // Twitter meta settings
        { hid: 'twitter:site', name: 'twitter:description', content: '@webtoolsmate' },
        { hid: 'twitter:card', name: 'twitter:card', content: 'summary_large_image' },
        { hid: 'twitter:url', name: 'twitter:url', content: `https://webtoolsmate.com/contact` },
        { hid: 'twitter:creator', name: 'twitter:creator', content: 'webtoolsmate' },
        { hid: 'twitter:title', name: 'twitter:title', content: `Contact Us | ${this.$config.siteName}` },
        { hid: 'twitter:description', name: 'twitter:description', content: `Our service team is here to assist with inquiries. Contact us using the form below, and we'll do our best to help.` },
        { hid: 'twitter:image', name: 'twitter:image', content: `https://webtoolsmate.com/storage/social/pages/contact.png` },
      ],
      link: [
        {
          hid: 'canonical',
          rel: 'canonical',
          href: `https://webtoolsmate.com${this.$route.path}`
        }
      ]
    }
  },
  data() {
    return {
      form: this.$vform({
        recaptcha: '',
        name: '',
        email: '',
        subject: '',
        description: ''
      })
    };
  },
  methods: {
    onError (error) {
      this.form.errors.set('message', 'Please validate the captcha field before submitting your request!');
    },
    async submit() {
      try {
        const token = await this.$recaptcha.getResponse();

        this.form.recaptcha = token;

        this.form.post(`/contact`).then(res => {
          this.form.reset();
        }).catch(e => {
          if ( e.response ) { 
            this.form.errors.set(e.response.data.errors);
          }
        });

        await this.$recaptcha.reset();

      } catch (e) {
          if ( e.response ) { 
            this.form.errors.set(e.response.data.errors);
          }
      }
    }
    //
  }
};
